import React, { useState } from 'react';
import ArticleView from './ArticleView';

function formatArticleDate(dateString) {
    if (!dateString) {
        return null;
    }

    const parsed = new Date(dateString);
    if (Number.isNaN(parsed.getTime())) {
        return dateString;
    }

    return parsed.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

function ArticleItem({ article, index, checked, onCheckboxChange }) {
    const [viewArticle, setViewArticle] = useState(false);

    const handlePrint = () => {
        window.open(`/print-article/${article.id}`, '_blank');
    };

    return (
        <>
            <div className={`ecx-page-list-item p-3 ${checked ? 'is-selected' : ''}`}>
                <div className="d-flex gap-3 align-items-start">
                    <div className="form-check flex-shrink-0 mt-1">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id={`article-${article.id}`}
                            checked={checked}
                            onChange={(e) => onCheckboxChange(e.target.checked, article.id, index)}
                        />
                    </div>

                    <div className="flex-grow-1 min-width-0">
                        <div className="d-flex flex-column flex-md-row align-items-md-start justify-content-md-between gap-2 mb-2">
                            <h6 className="article-item__title mb-0 fw-semibold">{article.title}</h6>

                            <div className="d-flex flex-wrap align-items-center gap-2">
                                {article.category && (
                                    <span className="ecx-page-chip">
                                        <i className="bi bi-folder2"></i>
                                        {article.category}
                                    </span>
                                )}
                                {article.status === false && (
                                    <span className="badge bg-light text-muted">Inactive</span>
                                )}
                            </div>
                        </div>

                        {article.summary && (
                            <p className="article-item__summary text-muted mb-3">{article.summary}</p>
                        )}

                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <div className="article-item__meta">
                                {article.modifiedAt && (
                                    <span className="article-item__meta d-inline-flex align-items-center gap-1">
                                        <i className="bi bi-calendar3"></i>
                                        Updated {formatArticleDate(article.modifiedAt)}
                                    </span>
                                )}
                            </div>

                            <div className="d-flex gap-2">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                                    onClick={() => setViewArticle(true)}
                                >
                                    <i className="bi bi-eye me-1"></i>
                                    View
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                                    onClick={handlePrint}
                                >
                                    <i className="bi bi-printer me-1"></i>
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ArticleView
                show={viewArticle}
                articleid={article.id}
                articlePreview={article}
                onClose={() => setViewArticle(false)}
            />
        </>
    );
}

export default ArticleItem;
